function addToCart() {
    return {
      loading: false,
  
      async submit(e) {
        this.loading = true;
  
        const form = e.target.closest('form');
        const formData = new FormData(form);
        formData.append("sections", "cart-items,cart-footer,cart-item-count");
        formData.append("sections_url", window.location.pathname);
  
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Accept': 'application/json'
            },
            body: formData
          });
  
          if (!response.ok) throw new Error('Failed to add to cart');
  
          const result = await response.json();
  
          const sectionsRes = await fetch('/?sections=cart-items,cart-footer,cart-item-count');
          const res = await sectionsRes.json();
        
          const parser = new DOMParser();
        
          const cartItemsHTML = res['cart-items'];
          const cartFooterHTML = res['cart-footer'];
          const cartItemCountHTML = res['cart-item-count'];
        
          const cartItemsDoc = parser.parseFromString(cartItemsHTML, 'text/html');
          const cartFooterDoc = parser.parseFromString(cartFooterHTML, 'text/html');
          const cartItemCountDoc = parser.parseFromString(cartItemCountHTML, 'text/html');
        
          const newCartItems = cartItemsDoc.querySelector('[data-cart-items]');
          const newCartFooter = cartFooterDoc.querySelector('[data-cart-footer]');
          const newItemCount = cartItemCountDoc.querySelector('body');
        
          if (newCartItems) {
            const currentCartItems = document.querySelector('[data-cart-items]');
            if (currentCartItems) currentCartItems.innerHTML = newCartItems.innerHTML;
          }
        
          if (newCartFooter) {
            const currentCartFooter = document.querySelector('[data-cart-footer]');
            if (currentCartFooter) currentCartFooter.innerHTML = newCartFooter.innerHTML;
          }
        
          if (newItemCount) {
            const cartCountElement = document.querySelector('#CartButton span');
            if (cartCountElement) cartCountElement.innerHTML = newItemCount.innerHTML;
          }

        } catch (error) {
          console.error('Add to cart error:', error);
        } finally {
          this.loading = false;
        }
      }
    };
}
  